export const convertColour = (colour: string): string => {
    if (colour.startsWith('#')) {
        return colour;
    }
    const [, r, g, b] = colour.split(',');

    return `rgb(${r.trim()}, ${g.trim()}, ${b.replaceAll(')', '').trim()})`;
};
